<span class="md-inputfield">
  <p-autoComplete
    ngModel
    #autocomplete
    [style]="{'width':'100%'}"
    [inputStyle]="{'width':'100%'}"
    name="{{autocompleteName}}"
    field="nome"
    [(ngModel)]="itemSelecionado"
    [suggestions]="resultset"
    [dropdown]="true"
    [size]="resultsetMaxSize"
    [forceSelection]="true"
    [tabindex]=2
    [required]="obrigatorio"
    [disabled]="bloqueado || formDisabled"
    (completeMethod)="search($event)"
    (onBlur)="onBlur($event)"
    (onSelect)="onSelect($event)"
    (onClear)="onClear()">
  </p-autoComplete>
  <label>{{placeholder}}</label>
</span>